<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vlz6pV/tc-custom/9781439676462.jpg?1702529635947" alt="This image is the cover for the book The Byrd Machine in Virginia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Byrd Machine in Virginia
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The Byrd Machine ran Virginia politics for more than half a century.</b></p><p>This political organization rose to power during the era of Jim Crow, wielding power and influence over everything from who got the nod to be governor to how the state maintained racial segregation. Inheriting its tactics from two previous political machines, the Byrd organization operated with a pathological hatred of debt spending, crushing the power of labor unions and forcing its will on Black schoolchildren protesting separate and unequal facilities. The nadir of its era was massive resistance, a move to close public schools rather than integrate them. </p><p>Journalist and author Michael Lee Pope details the rise and fall of the last great political machine in Virginia.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Lee Pope
      </h2>
      
      <p class="authorDescription body article">Michael Lee Pope is an award-winning journalist who lives in Old Town Alexandria. He has reported for NPR, the <I>New York Daily News</I> and <I>Northern Virginia</I> magazine. He has a master's degree in American studies from Florida State University, and he is a former adjunct professor at Tallahassee Community College.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?537dd20b